import {
  INTEGRATOR_MODULE_DEFINITIONS,
  integratorModuleLabel,
  type IntegratorSubappKey,
} from "@hub-modules";

import {
  buildHubDocumentTitle,
  resolveHubPageLabel,
  type BuildHubDocumentTitleInput,
} from "@/lib/hubBrowserTabTitle";

export {
  buildHubDocumentTitle,
  HUB_APPLE_TOUCH_ICON_LINK_ID,
  HUB_FAVICON_LINK_ID,
  hubEnvironmentTabSuffix,
  resolveHubPageLabel,
  standalonePageLabelForPath,
  type BuildHubDocumentTitleInput,
} from "@/lib/hubBrowserTabTitle";

/** Longest-prefix match for integrator module root from a pathname. */
export function integratorModuleKeyFromPathname(pathname: string): IntegratorSubappKey | null {
  const normalized = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  let best: { key: IntegratorSubappKey; pathLength: number } | null = null;

  for (const module of INTEGRATOR_MODULE_DEFINITIONS) {
    const root = module.path;
    if (normalized === root || normalized.startsWith(`${root}/`)) {
      if (best == null || root.length > best.pathLength) {
        best = { key: module.key, pathLength: root.length };
      }
    }
  }

  return best?.key ?? null;
}

export function buildHubDocumentTitleForRoute(input: {
  pathname: string;
  registeredPageLabel: string;
  moduleKey?: string | null;
  isDev?: boolean;
}): string {
  const moduleKey = input.moduleKey?.trim() ?? integratorModuleKeyFromPathname(input.pathname);
  const pageLabel = resolveHubPageLabel({
    pathname: input.pathname,
    registeredPageLabel: input.registeredPageLabel,
  });
  const titleInput: BuildHubDocumentTitleInput = {
    pageLabel,
    moduleLabel: moduleKey != null && moduleKey.length > 0 ? integratorModuleLabel(moduleKey) : "",
    isDev: input.isDev,
  };
  return buildHubDocumentTitle(titleInput);
}
